import script from "./ResumeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeView.vue?vue&type=script&setup=true&lang=js"

import "./ResumeView.vue?vue&type=style&index=0&id=0639398a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0639398a"]])

export default __exports__